<template>
    <MultiFactorAuthentication v-if="mfaRequired" :username=username :session=session @cancel="onCancel">
    </MultiFactorAuthentication>
    <PasswordAuthentication v-else @mfa-required="onSignIn"></PasswordAuthentication>
</template>

<script>
import PasswordAuthentication from "@/components/PasswordAuthentication.vue";
import MultiFactorAuthentication from "@/components/MultiFactorAuthentication.vue";
export default {
    name: "SignIn",
    components: {
        MultiFactorAuthentication,
        PasswordAuthentication
    },
    data() {
        return {
            username: null,
            session: null,
            mfaRequired: false,
        };
    },
    beforeCreate() {
        this.$store.commit('initializeStore');
    },
    methods: {
        onSignIn({ username, session }) {
            this.username = username;
            this.session = session;
            this.mfaRequired = true;
        },
        onCancel() {
            this.mfaRequired = false;
        }
    }
};
</script>